import { openToast } from 'src/redux/slices/toastReducer';
import { capitalize } from './string';

export const toast = (data, dispatch) => {
  dispatch(openToast({ toast: { message: capitalize(data.message), type: data.type } }));
};
